<template>
  <div class="inline-flex items-center">
    <span v-if="$slots.left" class="text-[16px] leading-[20px]">
      <slot name="left" />
    </span>
    <div
      class="relative inline-flex flex-shrink-0 h-[24px] transition-colors duration-200 ease-in-out border-[2px] border-transparent rounded-full w-[44px] focus:outline-none"
      :class="[disabledClasses, valueClasses]"
      @click="toggle"
    >
      <span
        aria-hidden="true"
        class="inline-block w-[20px] h-[20px] bg-[#FAFAFA] transition duration-200 ease-in-out transform rounded-full shadow pointer-events-none ring-0"
        :class="localValue ? 'translate-x-[20px]' : 'translate-x-0'"
      />
    </div>
    <span v-if="$slots.right" class="text-[16px] leading-[20px]">
      <slot name="right" />
    </span>
  </div>
</template>

<script>
export default {
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    value: {
      type: Boolean,
      default: false,
      require: true,
    },
    isGic: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      localValue: this.value,
    };
  },

  computed: {
    disabledClasses() {
      if (this.disabled) {
        return this.localValue ? 'bg-[#D3D8DE] cursor-default' : 'bg-[#787880] opacity-[0.16]';
      } else {
        return 'cursor-pointer';
      }
    },
    valueClasses() {
      if (this.localValue) {
        return this.isGic ? 'bg-orange' : 'bg-[#0EA5E9]';
      }
      return 'bg-[#787880] opacity-[0.16]';
    },
  },

  watch: {
    localValue(newValue) {
      this.$emit('input', newValue);
    },
    value(newValue) {
      this.localValue = newValue;
    },
  },
  methods: {
    toggle() {
      if (!this.disabled) {
        this.localValue = !this.localValue;
      }
    },
  },
};
</script>
